module.exports = __webpack_public_path__ + "static/media/Rococo-style-portrait-345273-min.475eeb40.jpg";